import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import purchaseOrderItemApi, {
  PurchaseOrderItemData
} from '../apis/purchaseOrderItem.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ContentAside from '../components/ContentAside'
import PurchaseOrderEditForm from '../partials/PurchaseOrderEditForm'
import ItemCard from '../components/ItemCard'

interface PurchaseOrderEditRouteState {
  id: number
}

interface PurchaseOrderEditProps
  extends RouteComponentProps<any, any, PurchaseOrderEditRouteState> {}

interface PurchaseOrderEditState {
  purchaseOrderItem: PurchaseOrderItemData | null
}

class PurchaseOrderEdit
  extends Component<PurchaseOrderEditProps, PurchaseOrderEditState> {
  constructor (props: PurchaseOrderEditProps) {
    super(props)
    this.state = {
      purchaseOrderItem: null
    }
  }

  get id () {
    return this.props.location.state.id
  }

  get form () {
    const { purchaseOrderItem } = this.state
    if (!purchaseOrderItem) return null
    return (
      <PurchaseOrderEditForm
        purchaseOrderItem={purchaseOrderItem} />
    )
  }

  get itemCard () {
    const { purchaseOrderItem } = this.state
    if (
      !purchaseOrderItem ||
      !purchaseOrderItem.item ||
      !purchaseOrderItem.purchaseOrder
    ) return null
    const { item, purchaseOrder } = purchaseOrderItem
    return (
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc}
        purchaseOrder={purchaseOrder.code} />
    )
  }

  readPurchaseOrderItem () {
    purchaseOrderItemApi.read(this.id, purchaseOrderItem => {
      if (!purchaseOrderItem) return
      this.setState({ purchaseOrderItem })
    })
  }

  componentDidMount () {
    this.readPurchaseOrderItem()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
        {this.form}
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(PurchaseOrderEdit)
